import { requiredRule, ValidatedDropDownList, ValidatedInput } from '@finbeat/react-toolkit';
import { useClientInfoTabContext } from 'providers/ClientInfoTabProvider';
import { useTranslation } from 'react-i18next';
import { Col } from 'reactstrap';
import '../OrderInfo.scss';
import { ClientTabEditedFieldProps } from '../Tabs/ClientTab';

const EditButtonPopover = () => {
    const { t } = useTranslation();
    const { dictionaries, dictLoading } = useClientInfoTabContext();

    return (
        <Col>
            <ValidatedDropDownList<ClientTabEditedFieldProps<any>>
                items={dictionaries.editingReason}
                name="reason"
                label={t('BackOfficeReason')}
                isLoading={dictLoading}
                isClearable={false}
                rules={{
                    required: requiredRule,
                }}
            />

            <ValidatedInput<ClientTabEditedFieldProps<any>>
                label={t('BackOfficeDescription')}
                type="textarea"
                name="dsc"
            />
        </Col>
    );
};

export default EditButtonPopover;
